import React, { useState } from 'react';
import { Typography, Button, Grid, TextField, Rating } from '@mui/material';
import { useHistory } from 'react-router-dom';
import CustomerLayout from '../CustomerLayout'; // ✅ Adjusted path for layout

const CustomerFeedbackAndRatings = () => {
  const [feedback, setFeedback] = useState('');
  const [rating, setRating] = useState(0);
  const history = useHistory();

  const handleFeedbackChange = (e) => {
    setFeedback(e.target.value);
  };

  const handleRatingChange = (newValue) => {
    setRating(newValue);
  };

  const handleSubmit = () => {
    // Implement logic to submit feedback and rating
    console.log('Feedback:', feedback);
    console.log('Rating:', rating);
    // After submission, redirect to dashboard or any other page
    history.push('/customer/dashboard');
  };

  return (
    <CustomerLayout>
    <div style={{ padding: '20px', textAlign: 'center' }}>
      <Typography variant="h3" style={{ marginBottom: '20px' }}>Feedback & Ratings</Typography>

      <TextField
        id="feedback"
        label="Enter your feedback"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        value={feedback}
        onChange={handleFeedbackChange}
        style={{ marginBottom: '20px' }}
      />

      <Typography variant="h6" style={{ marginBottom: '10px' }}>Rate your experience:</Typography>
      <Rating
        name="rating"
        value={rating}
        onChange={(event, newValue) => handleRatingChange(newValue)}
      />

      <Grid container justifyContent="center" style={{ marginTop: '20px' }}>
        <Grid item>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={handleSubmit}
          >
            Submit Feedback & Rating
          </Button>
        </Grid>
      </Grid>
    </div>
  </CustomerLayout>
  );
};

export default CustomerFeedbackAndRatings;
